// File: src/components/mixer/Color Mixer UI Components/SuccessMatchHeader.jsx
import React, { useEffect, useState } from 'react';

const styles = {
  container: {
    boxSizing: 'border-box',
    maxWidth: 680,
    width: '80%',
    margin: '12px auto 0',
    padding: '0 12px',
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
    textAlign: 'center',
    color: '#0b0b0b',
  },

  title: {
    margin: 0,
    fontSize: '1.85rem',
    fontWeight: 800,
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
  },

  // Crooked highlight pill (crooked box, straight text inside)
  highlight: {
    display: 'inline-block',
  padding: '3px 10px',
    paddingBottom: 4,
    borderRadius: 6,
    backgroundColor: '#3579F6',
    color: '#fff',
    transform: 'skewX(-8deg) rotate(-2deg)',
    
  },
  highlightText: {
    display: 'inline-block',
    transform: 'skewX(8deg) rotate(2deg)', // counters skew/rotation so text looks straight
  },

  subheading: {
    marginTop: 6,
    fontSize: '.9rem',
    color: '#6b7280',
    fontWeight: 500,
    lineHeight: 1.45,
  },

  timerWrapper: {
    marginTop: '18px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  timerLabelPill: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: 999,
    background: '#fff',
    border: '1px solid #e5e7eb',
    fontSize: '.7rem',
    color: '#374151',
    fontWeight: 800,
    letterSpacing: '.06em',
    textTransform: 'uppercase',
    marginBottom: 8,
  },
  digitsRow: { display: 'flex', alignItems: 'baseline', gap: 4 },
  digit: {
    display: 'inline-block',
    fontSize: '2.5rem',
    lineHeight: 1,
    fontWeight: 900,
    letterSpacing: '-0.02em',
    color: '#0f172a',
    fontVariantNumeric: 'tabular-nums',
    marginTop: 8,
  },
  colon: {
    fontSize: '2rem',
    fontWeight: 900,
    color: '#9ca3af',
    lineHeight: 1,
    padding: '8px 4px',
    transform: 'translateY(-5px)',
  },
};

export default function SuccessMatchHeader({ partnerName, yourName, endsAt }) {
  const [parts, setParts] = useState({ h: '--', m: '--', s: '--' });

  useEffect(() => {
    if (!endsAt) {
      setParts({ h: '--', m: '--', s: '--' });
      return;
    }
    const target = new Date(endsAt);
    const tick = () => {
      const diff = target.getTime() - Date.now();
      if (diff <= 0) {
        setParts({ h: '00', m: '00', s: '00' });
        return;
      }
      const total = Math.floor(diff / 1000);
      const h = Math.floor(total / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = total % 60;
      setParts({
        h: String(h).padStart(2, '0'),
        m: String(m).padStart(2, '0'),
        s: String(s).padStart(2, '0'),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [endsAt]);

  const hasHours = parts.h !== '00' && parts.h !== '--';

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>
        It’s a{' '}
        <span style={styles.highlight}>
          <span style={styles.highlightText}>Match</span>
        </span>
      </h1>

      <div style={styles.subheading}>
        You’re paired—say a quick hello before we kick off.
      </div>

      <div style={styles.timerWrapper}>
        <div style={styles.timerLabelPill}>Timer Ends IN</div>
        <div style={styles.digitsRow} aria-live="polite">
          {hasHours && (
            <>
              <span style={styles.digit}>{parts.h[0]}</span>
              <span style={styles.digit}>{parts.h[1]}</span>
              <span style={styles.colon}>:</span>
            </>
          )}
          <span style={styles.digit}>{parts.m[0]}</span>
          <span style={styles.digit}>{parts.m[1]}</span>
          <span style={styles.colon}>:</span>
          <span style={styles.digit}>{parts.s[0]}</span>
          <span style={styles.digit}>{parts.s[1]}</span>
        </div>
      </div>
    </div>
  );
}
